export default __webpack_public_path__ + "static/media/Condiciones generales 1a convocatoria banco de jurados 2026_CB_ DP_AF_Final.cbe1a220.pdf";